import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card card-flush pt-3 mb-5 mb-lg-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#performance-report",
  "aria-expanded": "true",
  "aria-controls": "performance-report"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Parametreler - Sipariş Raporu")
  ])
], -1)
const _hoisted_3 = {
  id: "performance-report",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body p-9" }
const _hoisted_5 = { class: "row g-12 mb-8" }
const _hoisted_6 = { class: "col-md-4 fv-row" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Sipariş Tarihi 1", -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Sip. Tarihi", -1)
const _hoisted_12 = { class: "col-md-4 fv-row" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Yükleme Tarihi 1", -1)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Yükleme Tarihi 2", -1)
const _hoisted_18 = { class: "col-md-4 fv-row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Müşteri", -1)
const _hoisted_20 = { class: "position-relative align-items-center" }
const _hoisted_21 = { class: "row g-12 mb-8" }
const _hoisted_22 = { class: "col-md-4 fv-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Üretici", -1)
const _hoisted_24 = { class: "position-relative align-items-center" }
const _hoisted_25 = { class: "col-md-4 fv-row" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Departman", -1)
const _hoisted_27 = { class: "position-relative align-items-center" }
const _hoisted_28 = { class: "col-md-4 fv-row" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Sezon", -1)
const _hoisted_30 = { class: "row g-12 mb-8" }
const _hoisted_31 = { class: "col-md-2 fv-row" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Sipariş Durumu", -1)
const _hoisted_33 = { class: "col-md-2 fv-row" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "öko-Tex ", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = { class: "col-md-3 fv-row" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Marka ", -1)
const _hoisted_38 = { class: "col-md-2 fv-row" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Sipariş Şekli ", -1)
const _hoisted_40 = { class: "col-md-3 fv-row" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Kumaş Onayı Tarihi", -1)
const _hoisted_42 = { class: "row g-12 mb-8" }
const _hoisted_43 = { class: "col-md-4 fv-row" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Yükleme Şekli", -1)
const _hoisted_45 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_46 = {
  key: 0,
  class: "card card-flush pt-3 mb-5 mb-lg-10"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Sipariş Raporu")
  ])
], -1)
const _hoisted_48 = { class: "card-body" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-md-12" }
const _hoisted_51 = { class: "table-responsive" }
const _hoisted_52 = { style: {"text-align":"left"} }
const _hoisted_53 = { class: "image-text" }
const _hoisted_54 = { class: "image-text" }
const _hoisted_55 = { class: "image-text" }
const _hoisted_56 = { class: "image-text" }
const _hoisted_57 = { class: "image-text" }
const _hoisted_58 = { class: "image-text" }
const _hoisted_59 = { class: "image-text" }
const _hoisted_60 = { class: "image-text" }
const _hoisted_61 = { class: "image-text" }

import { defineComponent, ref, computed } from "vue";

import Breadcrumb from "primevue/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Department from "@/components/departments/Department.vue";
import Customer from "@/components/customers/CustomerSingleSelect.vue";
import Supplier from "@/components/suppliers/SupplierSingleSelect.vue";
import Season from "@/components/seasons/Season.vue";
import DepartmentMultiSelect from "@/components/departments/DepartmentMultiSelect.vue";
import SeasonMultiSelect from "@/components/seasons/SeasonMultiSelect.vue";
import CustomerMultiSelect from "@/components/customers/CustomerMultiSelect.vue";
import SupplierMultiSelect from "@/components/suppliers/SupplierMultiSelect.vue";
import BrandMultiSelect from "@/components/brands/BrandMultiSelect.vue";
import OrderTypeMultiSelect from "@/components/orderTypes/OrderTypeMultiSelect.vue";
import ShippingTypeMultiSelect from "@/components/shippingTypes/ShippingTypeMultiSelect.vue";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import moment from "moment";
import PrintReport from "./components/print-order-report.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import InputMask from "primevue/inputmask";
import Status from "@/views/apps/orders/components/Status.vue";
import OekoTex from "./components/OekoTex.vue";
import Checkbox from "primevue/checkbox";
import Calendar from "primevue/calendar";
//import { components } from "@/assets/ts";
import { useRouter, useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const router = useRouter();
const store = useStore();
const isActive = ref(false);
const date: any = ref();
const customers: any = ref();
const suppliers: any = ref();
const departmentId: any = ref();
const seasonIds: any = ref();
const symbol: any = ref();
const deliveryDate: any = ref();
const deliveryDateOne: any = ref();
const deliveryDateTwo: any = ref();
const orderDate: any = ref();
const orderDateOne: any = ref();
const orderDateTwo: any = ref();
const brandIds: any = ref();
const orderTypeIds: any = ref();
const fabricApprovalDate: any = ref();
const shippingTypeIds: any = ref();
const toggleModal = () => {
  isActive.value = !isActive.value;
};
const totalPrice = () => {
  var response = test.value
    .map((f) => f.totalPrice)
    .reduce(function (a, b) {
      return a + b;
    }, 0)
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
    .replace(/\.(\d+)$/, ",$1")
    .toString();

  return response;
};
const deliveryTotalPrice = () => {
  var response = test.value
    .map((f) => f.deliveryTotalPrice)
    .reduce(function (a, b) {
      return a + b;
    }, 0)
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
    .replace(/\.(\d+)$/, ",$1")
    .toString();

  return response;
};
const totalOrderQuantity = ref(555);
const filters = ref({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  orderId: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  orderQuantity: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  deliveryDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  shippingDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  orderDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  customerName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  articleNumber: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  department: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  seasonName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  order: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  supplierName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  modelCode: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  oekoTex: { value: null, matchMode: FilterMatchMode.EQUALS },
  brandName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  orderTypeName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  fabricApproval: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  shippingTypeName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
});
const selectedCustomer = (args) => {
  customers.value = args.value;
};
const selectedDepartment = (args) => {
  departmentId.value = args.value;
};
const selectedSupplier = (args) => {
  suppliers.value = args.value;
};
const selectedSeason = (args) => {
  if (args.value) {
    seasonIds.value = args.value;
  } else {
    seasonIds.value = [];
  }
};
const selectedYear = (args) => {
  date.value = args.value;
};

const orderReportList = computed(
  () => store.state.ReportModule.orderReport.value || []
);

const send = () => {
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
  var model = {
    status: statusModel.value,
    orderDateOne: orderDateOne.value,
    orderDateTwo: orderDateTwo.value,
    deliveryDateOne: deliveryDateOne.value,
    deliveryDateTwo: deliveryDateTwo.value,
    fabricApprovalDate: fabricApprovalDate.value,
    customerIds: customers.value ? customers.value.map((f) => f.id) : [],
    supplierIds: suppliers.value ? suppliers.value.map((f) => f.id) : [],
    departmentIds: departmentId.value
      ? departmentId.value.map((f) => f.value)
      : [],
    seasonIds: seasonIds.value ? seasonIds.value.map((f) => f.value) : [],
    brandIds: brandIds.value ? brandIds.value.map((f) => f.value) : [],
    orderTypeIds: orderTypeIds.value
      ? orderTypeIds.value.map((f) => f.value)
      : [],
    shippingTypeIds: shippingTypeIds.value
      ? shippingTypeIds.value.map((f) => f.value)
      : [],
    currencyTypeId: 1,
    oekotex: oekotexModel.value,
  };
  symbol.value = model.currencyTypeId == 1 ? "€" : "$";

  store.dispatch(Actions.ORDER_REPORT_LIST, model).then(() => {
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  });
};
const filteredData = ref();
const filterData = (data) => {
  filteredData.value = data;
};
const test = computed(() => filteredData.value || []);
const exportExcel = () => {
  import("xlsx").then((xlsx) => {
    const data = filteredData.value.map((x) => {
      return {
        "Sip.no": x.orderId,
        Tarih: moment(x.orderDate).format("DD.MM.YYYY"),
        Müşteri: x.customerName,
        Marka: x.brandName || "-",
        "Dep.": x.department,
        Üretici: x.supplierName,
        "Model no": x.modelCode,
        Artikel: x.articleNumber,
        "Order no": x.order,
        "Sip.şekli": x.orderTypeName || "-",
        "Yükleme şekli": x.shippingTypeName || "-",
        "Kumaş onayı": x.fabricApproval
          ? moment(x.fabricApproval).format("DD.MM.YYYY")
          : "-",
        öko: x.oekoTex == true ? "Var" : "Yok",
        Sezon: x.seasonName,
        "Yükleme Tarihi": moment(x.shippingDate).format("DD.MM.YYYY"),
        "Varış Tarihi": moment(x.deliveryDate).format("DD.MM.YYYY"),
        "Sip. Adedi": x.orderQuantity,
        Fiyat: x.orderLinePrice
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
          .replace(/\.(\d+)$/, ",$1")
          .toString(),
        "Toplam Tutar": x.totalPrice
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
          .replace(/\.(\d+)$/, ",$1")
          .toString(),
        "Sevk Edilen": x.shipped,
        "Sevk Tutar": x.deliveryTotalPrice
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
          .replace(/\.(\d+)$/, ",$1")
          .toString(),
      };
    });

    const ws = xlsx.utils.json_to_sheet(data);
    const wb = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, "sheet01");
    xlsx.utils.sheet_add_aoa(
      ws,
      [
        [
          "Toplam",
          filteredData.value
            .map((f) => f.orderQuantity)
            .reduce(function (a, b) {
              return a + b;
            }, 0),
          "",
          filteredData.value
            .map((f) => f.orderLinePrice * f.orderQuantity)
            .reduce(function (a, b) {
              return a + b;
            }, 0)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
            .replace(/\.(\d+)$/, ",$1")
            .toString() +
            " " +
            (symbol.value == null ? " €" : symbol.value),

          filteredData.value
            .map((f) => f.shipped)
            .reduce(function (a, b) {
              return a + b;
            }, 0),
          filteredData.value
            .map((f) => f.orderLinePrice * f.shipped)
            .reduce(function (a, b) {
              return a + b;
            }, 0)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
            .replace(/\.(\d+)$/, ",$1")
            .toString() +
            " " +
            (symbol.value == null ? " €" : symbol.value),
        ],
      ],
      { origin: "P" }
    );
    const fileName = `order_report_${moment(new Date()).format()}.xlsx`;

    xlsx.writeFile(wb, fileName);
  });
};
const statusModel = ref();
const oekotexModel = ref();
const selectedStatus = (args) => {
  statusModel.value = args.value.value;
};
const selectedOekoTex = (args) => {
  if (args.value != null) {
    oekotexModel.value = args.value.value;
  } else {
    oekotexModel.value = null;
  }
};

const clearFilter1 = () => {
  initFilters1();
};
const initFilters1 = () => {
  filters.value = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    orderId: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    orderQuantity: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    deliveryDate: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    orderDate: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    shippingDate: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    customerName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    articleNumber: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    department: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    seasonName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    order: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    supplierName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    modelCode: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    brandName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    orderTypeName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    fabricApproval: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    shippingTypeName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    oekoTex: { value: null, matchMode: FilterMatchMode.EQUALS },
  };
};

const selectedBrand = (args) => {
  brandIds.value = args.value;
};

const selectedOrderType = (args) => {
  orderTypeIds.value = args.value;
};

const selectedShippingType = (args) => {
  shippingTypeIds.value = args.value;
};

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Row = _resolveComponent("Row")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((orderDateOne).value = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, orderDateOne.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((orderDateTwo).value = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, orderDateTwo.value]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((deliveryDateOne).value = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, deliveryDateOne.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((deliveryDateTwo).value = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, deliveryDateTwo.value]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createVNode(CustomerMultiSelect, { onChangeCustomer: selectedCustomer })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createVNode(SupplierMultiSelect, {
                  class: "col-md-12",
                  onChangeSupplier: selectedSupplier
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _createVNode(DepartmentMultiSelect, {
                  class: "col-md-12",
                  onChangeDepartment: selectedDepartment
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode(SeasonMultiSelect, {
                class: "col-md-12",
                onChangeSeason: selectedSeason
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createVNode(Status, {
                onChangeStatus: selectedStatus,
                data: { isActive: 0 }
              })
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _hoisted_35,
              _createVNode(_unref(Checkbox), {
                id: "binary",
                modelValue: oekotexModel.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((oekotexModel).value = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createVNode(BrandMultiSelect, {
                class: "col-md-12",
                onChangeBrand: selectedBrand
              })
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createVNode(OrderTypeMultiSelect, {
                class: "col-md-12",
                onChangeOrderType: selectedOrderType
              })
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createVNode(_unref(Calendar), {
                modelValue: fabricApprovalDate.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((fabricApprovalDate).value = $event)),
                dateFormat: "dd.mm.yy",
                placeholder: "Kumaş onay tarihi seçin",
                class: "w-100"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createVNode(ShippingTypeMultiSelect, {
                class: "col-md-12",
                onChangeShippingType: selectedShippingType
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("button", {
          id: "performance-report_submit",
          ref: "submitButtonSettings",
          class: "btn btn-primary",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (send()))
        }, " Görüntüle ", 512)
      ])
    ]),
    (_unref(orderReportList).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_DataTable, {
                    showGridlines: "",
                    removableSort: "",
                    onValueChange: filterData,
                    value: _unref(store).state.ReportModule.orderReport.value,
                    class: "p-datatable-sm",
                    stripedRows: "",
                    responsiveLayout: "scroll",
                    filters: filters.value,
                    "onUpdate:filters": _cache[8] || (_cache[8] = ($event: any) => ((filters).value = $event)),
                    filterDisplay: "menu",
                    dataKey: "id",
                    paginator: true,
                    rows: 50,
                    style: {"width":"max-content","min-width":"-webkit-fill-available","font-size":"11px","max-width":"90% !important","font-weight":"bold"}
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_Button, {
                          icon: "pi pi-print",
                          class: "p-button-rounded btn btn-primary",
                          style: {"padding":"0","margin-right":"5px"},
                          onClick: toggleModal
                        }),
                        _createVNode(_component_Button, {
                          icon: "pi pi-file-excel",
                          class: "p-button-rounded btn btn-primary",
                          onClick: exportExcel,
                          style: {"padding":"0"}
                        }),
                        _createVNode(_component_Button, {
                          type: "button",
                          icon: "pi pi-filter-slash",
                          label: "Temizle",
                          class: "p-button-outlined",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (clearFilter1())),
                          style: {"margin-left":"10px"}
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(Column), {
                        field: "orderId",
                        header: "Sip.no",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"6rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_53, _toDisplayString(data.orderId), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Sipariş Numarası Ara...    "
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "orderDate",
                        header: "Tarih",
                        sortable: true,
                        filterMatchMode: "contains",
                        style: {"min-width":"2rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_54, _toDisplayString(_unref(moment)(data.orderDate).format("DD.MM.YYYY")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "customerName",
                        header: "Müşteri",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_55, _toDisplayString(data.customerName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "brandName",
                        header: "Marka",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"8rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.brandName || "-"), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Marka ara.."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "department",
                        header: "Departman",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"8rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_56, _toDisplayString(data.department), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "supplierName",
                        header: "Üretici",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_57, _toDisplayString(data.supplierName), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Üretici içinde ara.."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "modelCode",
                        header: "Model no",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"6rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_58, _toDisplayString(data.modelCode), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Model Kodu İçinde Ara"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "articleNumber",
                        header: "Artikel",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"3rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_59, _toDisplayString(data.articleNumber), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Artikel içinde ara.."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "order",
                        header: "Order no",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"5rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_60, _toDisplayString(data.order), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Order içinde ara.."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "orderTypeName",
                        header: "Sipariş Şekli",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"8rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.orderTypeName || "-"), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Sipariş şekli ara.."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "shippingTypeName",
                        header: "Yükleme Şekli",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"8rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.shippingTypeName || "-"), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Yükleme şekli ara.."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "fabricApproval",
                        header: "Kumaş Onayı",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.fabricApproval
                      ? _unref(moment)(data.fabricApproval).format("DD.MM.YYYY")
                      : "-"), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Kumaş onayı ara.."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "oekoTex",
                        header: "öko",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"2rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", _hoisted_61, [
                            _createVNode(_unref(Checkbox), {
                              id: "binary",
                              modelValue: data.oekoTex,
                              "onUpdate:modelValue": ($event: any) => ((data.oekoTex) = $event),
                              binary: true,
                              disabled: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_Dropdown, {
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            options: [
                      { label: 'Yok', value: false },
                      { label: 'Var', value: true },
                    ],
                            optionLabel: "label",
                            optionValue: "value",
                            class: "p-column-filter",
                            placeholder: "Seçiniz",
                            showClear: true
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "seasonName",
                        header: "Sezon",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"6rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.seasonName), 1)
                        ]),
                        filter: _withCtx(({ filterModel }) => [
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            class: "p-column-filter",
                            placeholder: "Sezon ara.."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "shippingDate",
                        header: "Yükleme Tarihi",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(_unref(moment)(data.shippingDate).format("DD.MM.YYYY")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "deliveryDate",
                        header: "Varış Tarihi",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createTextVNode(_toDisplayString(_unref(moment)(data.deliveryDate).format("DD.MM.YYYY")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "orderQuantity",
                        header: "Sip. Adedi",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"},
                        class: "text-end"
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.orderQuantity), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "orderLinePrice",
                        header: "Fiyat",
                        sortable: "",
                        class: "text-end",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(parseFloat(data.orderLinePrice)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "orderLinePrice",
                        header: "Toplam Tutar",
                        class: "text-end",
                        sortable: "",
                        filterMatchMode: "contains",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(parseFloat(data.totalPrice)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "shipped",
                        header: "Sevk Edilen",
                        sortable: "",
                        filterMatchMode: "contains",
                        class: "text-end",
                        style: {"min-width":"4rem","font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", null, _toDisplayString(data.shipped), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "deliveryTotalPrice",
                        header: "Sevk Tutar",
                        sortable: "",
                        filterMatchMode: "contains",
                        class: "text-end",
                        style: {"font-weight":"bold"}
                      }, {
                        body: _withCtx(({ data }) => [
                          _createTextVNode(_toDisplayString(parseFloat(data.deliveryTotalPrice)
                      .toFixed(2)
                      .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                      .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(ColumnGroup), { type: "footer" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Row, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Column), {
                                footer: "",
                                colspan: 16,
                                footerStyle: "text-align:right"
                              }),
                              _createVNode(_unref(Column), {
                                footer: 
                      _unref(test)
                        .map((f) => f.orderQuantity)
                        .reduce(function (a, b) {
                          return a + b;
                        }, 0)
                    ,
                                class: "text-end"
                              }, null, 8, ["footer"]),
                              _createVNode(_unref(Column), { footer: "" }),
                              _createVNode(_unref(Column), {
                                footer: totalPrice() + (symbol.value == null ? ' €' : symbol.value),
                                class: "text-end"
                              }, null, 8, ["footer"]),
                              _createVNode(_unref(Column), {
                                footer: 
                      _unref(test)
                        .map((f) => f.shipped)
                        .reduce(function (a, b) {
                          return a + b;
                        }, 0)
                    ,
                                class: "text-end"
                              }, null, 8, ["footer"]),
                              _createVNode(_unref(Column), {
                                footer: 
                      deliveryTotalPrice() + (symbol.value == null ? ' €' : symbol.value)
                    ,
                                class: "text-end"
                              }, null, 8, ["footer"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "filters"])
                ])
              ])
            ])
          ]),
          (isActive.value)
            ? (_openBlock(), _createBlock(PrintReport, {
                key: 0,
                isActive: isActive.value,
                data: filteredData.value || _unref(orderReportList),
                currencyType: symbol.value,
                onChangeReceipt: toggleModal
              }, null, 8, ["isActive", "data", "currencyType"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})